module.exports = __webpack_public_path__ + "img/img01.4e022694.png";